module.exports = __webpack_public_path__ + "static/media/grafos.59b2fe05.png";